import { z } from 'zod'

export const ShippingProvider = z.object({
    id: z.number(),
    name: z.string().max(64),
    shipping_provider_id: z.string().max(32),
    can_get_quote: z.boolean().default(false),
    can_cancel: z.boolean().default(false),
    can_update: z.boolean().default(false),
    has_cover_sheet: z.boolean().default(false),
    data: z.record(z.unknown()).nullable(),
    logo_url: z.string(),
})

export type ShippingProvider = z.infer<typeof ShippingProvider>
